import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SignInWithSsoFormValues } from '../common/interfaces';
import { SignInWithSsoView } from './signInWithSsoView';
import { validatePartner } from '../data/endpointServices';
import { getReturnUrl } from '../common/returnUrl';
import { routes } from '../common/routes';

export const SignInWithSsoPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [showInvalidPartnerMessage, setShowInvalidPartnerMessage] = useState<boolean>(false);
    const [serverError, setServerError] = useState<string>('');
    const returnUrl = getReturnUrl();
    const { errors: fieldsErrors, handleSubmit, register } = useForm();

    const submitSignInWithSso = async(data: SignInWithSsoFormValues) => {
        setShowInvalidPartnerMessage(false);

        try {
            if (data) {
                const response = await validatePartner(data.domain);
                if (response?.data?.r?.isv) {
                    const partnerName = response?.data?.r?.pn;
                    window.location.href = `${routes.challengeUrl}?partnerName=${partnerName}&returnUrl=${returnUrl}`;
                } else {
                    setShowInvalidPartnerMessage(true);
                }
            }
        } catch (error) {
            if (error.response.data.c === 400) {
                setServerError(error.response.data.e);
            } else {
                setServerError(t('logInSystemError'));
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <SignInWithSsoView
            submitSignInWithSso={submitSignInWithSso}
            fieldsErrors={fieldsErrors}
            handleSubmit={handleSubmit}
            register={register}
            showInvalidPartnerMessage={showInvalidPartnerMessage}
            loading={loading}
            serverError={serverError}
        />
    );
};

